export interface SectionDefinition {
	key: string;
	label: string;
	titleSettingName: string;
	shownSettingName: string;
}

export const SECTION_DEFINITIONS: SectionDefinition[] = [
	{
		key: "PROMOTIONS",
		label: "Promotions",
		titleSettingName: "HOMEPAGE_PROMOTIONS_TITLE",
		shownSettingName: "HOMEPAGE_PROMOTIONS_TITLE_SHOWN"
	},
	{
		key: "QUICK_LINKS",
		label: "Quick Links",
		titleSettingName: "HOMEPAGE_QUICK_LINKS_TITLE",
		shownSettingName: "HOMEPAGE_QUICK_LINKS_TITLE_SHOWN"
	},
	{
		key: "KEYSHOUTS",
		label: "Key Shouts",
		titleSettingName: "HOMEPAGE_KEYSHOUTS_TITLE",
		shownSettingName: "HOMEPAGE_KEYSHOUTS_TITLE_SHOWN"
	},
	{
		key: "FAVOURITE_FEEDS",
		label: "Favourite Feeds",
		titleSettingName: "HOMEPAGE_FAVOURITE_FEEDS_TITLE",
		shownSettingName: "HOMEPAGE_FAVOURITE_FEEDS_TITLE_SHOWN"
	},
	{
		key: "3CELEBRATES_THANKS",
		label: "Recognition",
		titleSettingName: "HOMEPAGE_3CELEBRATES_THANKS_TITLE",
		shownSettingName: "HOMEPAGE_3CELEBRATES_THANKS_TITLE_SHOWN"
	}
];
